// This should only be used for displaying messages (like "Item updated")
import Vue from 'vue';
const EventBus = new Vue()

export const SUCCESS = "success";
export const INFO = "info";
export const ERROR = "error";


export default {
    success: function (message) {
        EventBus.$emit('message', {type: SUCCESS, message: message, target: this.target})
    },

    error: function (message) {
        EventBus.$emit('message', {type: ERROR, message: message, target: this.target})
    },

    info: function (message) {
        EventBus.$emit('message', {type: INFO, message: message, target: this.target})
    },

    clear: function () {
        EventBus.$emit('message.clear')
    },

    data: function () {
        return {
            target: null
        }
    },

    bus: EventBus
}


// WEBPACK FOOTER //
// ./src/utils/messages.js